/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import { calculateSizes } from "./utils";
import { useDtfStore } from "../store";
import { renderList } from "common/vue/render-list";
import "./Styles.scss";

export default function JerseyNumbersStyle({ ...restProps }) {
  const options = [
    {
      label: "Solid Numbers",
      value: "solid"
    },
    {
      label: "Outline Numbers",
      value: "outline"
    },
    {
      label: "Promesh",
      value: "promesh"
    },
    {
      label: "Soccer League",
      value: "soccer-league"
    },
    {
      label: "Octin Sports",
      value: "octin-sports"
    },
    {
      label: "Rueckwarzsalto",
      value: "rueckwarzsalto"
    },
    {
      label: "Varsity Team",
      value: "varsity-team"
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    // @ts-expect-error TS(4111): Property 'letterNumberArtwork' comes from an index... Remove this comment to see the full error message
    return store.letterNumberArtwork;
  }

  function handleSelect(option: any) {
    const style = option.value;
    const sizes = calculateSizes({
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...letterNumberArtwork(),
      style
    });
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateArtworkValues({
      index: 0,
      style,
      sizes
    });
    if (Object.keys(sizes).length) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      store.getArtworksPricing();
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.updateJerseyNumberPdpDates();
  }

  return (
    // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
    <div {...restProps} className={cn("jersey-numbers-style", restProps.className)}>
      {renderList(options, option => (
        <div
          className={cn({
            "jersey-numbers-style__item": true,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            "jersey-numbers-style__item--selected": option.value === letterNumberArtwork().style
          })}
          key={option.value}
          onClick={() => {
            handleSelect(option);
          }}
          data-testid="styles-div"
        >
          <div
            className={cn({
              "jersey-numbers-style__text": true,
              [`jersey-numbers-style__text--${option.value}`]: true
            })}
          >
            {" "}
            12345
            <br />
            67890{" "}
          </div>
          <span className="jersey-numbers-style__label">{option.label}</span>
        </div>
      ))}
    </div>
  );
}
